export default __webpack_public_path__ + "static/media/mittellanger_bus_hinten.889c3524.jpg";